










import { Component, Vue, Prop } from 'vue-property-decorator';
import CPrgTreeTable from '@/modules/budget/alteration/form/tabs/components/CreateForm/SpfTreeTables/CPrgTreeTable.vue';
import CGuTreeTable from '@/modules/budget/alteration/form/tabs/components/CreateForm/SpfTreeTables/CGuTreeTable.vue';
import CAbpGuTreeTable from '@/modules/budget/alteration/form/tabs/components/CreateForm/SpfTreeTables/CAbpGuTreeTable.vue';
import CAbpPrgTreeTable from '@/modules/budget/alteration/form/tabs/components/CreateForm/SpfTreeTables/CAbpPrgTreeTable.vue';

@Component({
    name: 'c-spf-tree-table',
    components: {
        'c-prg-tree-table': CPrgTreeTable,
        'c-gu-tree-table': CGuTreeTable,
        'c-abp-gu-tree-table': CAbpGuTreeTable,
        'c-abp-prg-tree-table': CAbpPrgTreeTable
 }
})
export default class CSpfTreeTable extends Vue {
    @Prop({
        required: true,
        default: null
    })
    private tableData!: any;

    @Prop({
        required: true,
        default: []
    })
    private editedMonths!: number[]; // 0-11

    @Prop({
        required: true,
        default: null
    })
    private accessLevel!: any;

    @Prop({
        required: true,
        default: null
    })
    private uSumVisible!: number;

    @Prop({
        required: false,
        default: 0
    })
    private tableType!: number;

    @Prop({
        required: false,
        default: ''
    })
    private flc2!: any;

    @Prop({
        required: false,
        default: ''
    })
    private flc4!: any;

    @Prop({
        required: true,
        default: []
    })
    private createdMonths!: number; // 0-11

    @Prop({
        required: true,
        default: true
    })
    private withGU!: boolean;

    // --- Колонка "Примечание" (причина отклонения), разрез "по АБП": заявка АБП - c-prg-tree-table (EAK-1557),
    // справка (расходы) - c-abp-prg-tree-table, только просмотр (EAK-808) ---
    @Prop({
        required: false,
        default: false
    })
    private reasonVisible!: boolean;

    @Prop({
        required: false,
        default: false
    })
    private reasonEditable!: boolean;

    @Prop({
        required: false,
        default: () => ({})
    })
    private reasonGroups!: any;

    @Prop({
        required: false,
        default: 1
    })
    private reasonPlanType!: number;

    private editReason(target: any) {
        this.$emit('editReason', target);
    }
    private viewReason(group: any) {
        this.$emit('viewReason', group);
    }
    private chgData(data: any) {
        this.$emit('chgData', data);
    }
    private agrBtn(val: any) {
        this.$emit('agrBtn', val);
    }
    private flcControls(val: any) {
        this.$emit('flcControls', val);
    }
    private treeData: any[] = [];

    private tree(value: any) {
        this.treeData = value
    }
    private addItem(val: any) {
        this.$emit('addItem', val);
    }
}

